import { useQuery, useApolloClient } from '@apollo/client';
import PropTypes from 'prop-types';

import ArticleListFetchQuery from './ArticleListFetchQuery';

const ArticleFetchListConnectorApollo = ({ children, categories, category, articlesPerPage }) => {
  const client = useApolloClient();
  const { loading, error, data } = useQuery(ArticleListFetchQuery, {
    variables: {
      categoryIdentifier: category,
      pageNumber: 1,
      articlesPerPage,
    },
    fetchPolicy: 'cache-first',
    onCompleted: () => {
      categories.forEach((CATEGORY) => {
        client.query({
          query: ArticleListFetchQuery,
          variables: {
            categoryIdentifier: CATEGORY,
            pageNumber: 1,
            articlesPerPage,
          },
        });
      });
    },
  });

  const result = {
    loading,
    error,
  };

  if (error) {
    throw error;
  }

  if (!loading) {
    result.articleList = data.article;
    result.articlePagination = data.articlePagination || { articlesCount: 0, pageCount: 0 };
  }

  return children(result);
};

ArticleFetchListConnectorApollo.propTypes = {
  children: PropTypes.func.isRequired,
  category: PropTypes.string,
};

ArticleFetchListConnectorApollo.defaultProps = {
  category: null,
};

export default ArticleFetchListConnectorApollo;
